export default __webpack_public_path__ + "static/media/24-life-logo-mobile-2x 1.329150fd.svg";